import dayjs from 'dayjs';

import type { RequestCreateDetailsDTO } from '@/pages/Administration/AdministrationPcapRequests/AdministrationPcapRequests.types';

const EMPTY_PCAP_REQUEST_DIALOG: RequestCreateDetailsDTO = {
  end: dayjs(),
  purpose: '',
  query: '',
  start: dayjs(),
  sensors: []
};

export default EMPTY_PCAP_REQUEST_DIALOG;
